import * as React from 'react'
import { Dimensions, StatusBar, Animated, Pressable } from 'react-native'
import { TabView, SceneMap } from 'react-native-tab-view'
import { Box, View } from 'native-base'
import PayoutHistory from '../components/ManagerPayments/PayoutHistory'
import BankInformation from '../components/ManagerPayments/BankInformation'
import TransactionHistory from '../components/ManagerPayments/TransactionHistory'
import AppBarHeader from '../components/AppBar'
import { useTranslation } from 'react-i18next'

const FirstRoute = () => <PayoutHistory />

const SecondRoute = () => <TransactionHistory />

const ThirdRoute = () => <BankInformation />

const initialLayout = { width: Dimensions.get('window').width }

const renderScene = SceneMap({
  first: FirstRoute,
  second: SecondRoute,
  third: ThirdRoute,
})

export const ManagerAccount = () => {
  const { t } = useTranslation()
  const [index, setIndex] = React.useState(0)
  const [routes] = React.useState([
    { key: 'first', title: t('managerAccount.payoutHistory') },
    { key: 'second', title: t('managerAccount.transactionHistory') },
    { key: 'third', title: t('managerAccount.bank') },
  ])

  const renderTabBar = (props) => {
    const inputRange = props.navigationState.routes.map((x, i) => i)
    return (
      <Box flexDirection="row">
        {props.navigationState.routes.map((route, i) => {
          const opacity = props.position.interpolate({
            inputRange,
            outputRange: inputRange.map((inputIndex) =>
              inputIndex === i ? 1 : 0.5
            ),
          })
          const color = index === i ? '#1f2937' : '#a1a1aa'
          const borderColor = index === i ? 'yellow.400' : 'coolGray.200'

          return (
            <Box
              key={route.key}
              borderBottomWidth="3"
              borderColor={borderColor}
              flex={1}
              alignItems="center"
              p="3"
              cursor="pointer"
            >
              <Pressable
                onPress={() => {
                  setIndex(i)
                }}
              >
                <Animated.Text style={{ color }}>{route.title}</Animated.Text>
              </Pressable>
            </Box>
          )
        })}
      </Box>
    )
  }

  return (
    <View>
      <AppBarHeader />
      <View pl="10%" pr="10%">
        <TabView
          navigationState={{ index, routes }}
          renderScene={renderScene}
          renderTabBar={renderTabBar}
          onIndexChange={setIndex}
          initialLayout={initialLayout}
          style={{ marginTop: StatusBar.currentHeight }}
        />
      </View>
    </View>
  )
}

export default ManagerAccount
